import { UserRoles } from '../../../utils/constants';

export const gamePermissions = {
  'game.connect': [UserRoles.Student, UserRoles.Coach, UserRoles.Ogma],
};
